import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../icon/icon.module';
import { BadgeComponent } from './badge.component';

@NgModule({
  imports: [IconModule, CommonModule],
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
})
export class BadgeModule {}
export { BadgeComponent } from './badge.component';
export { BadgeColor } from './badge.types';
